module.exports = __webpack_public_path__ + "static/media/media.5d190925.png";